var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Modal2 } from '../common/Modal';
import { List, ListItemInput, ListItemTextArea, ListItemSwitch, } from '@bootstraplabs/bsw-common-react';
export function CreateEventModal(props) {
    // State
    var _a = useState(''), name = _a[0], setName = _a[1];
    var _b = useState(''), description = _b[0], setDescription = _b[1];
    var _c = useState(false), published = _c[0], setPublished = _c[1];
    // Check input
    var nameOk = name.trim().length > 0 && name.trim().length <= 100;
    var descriptionOk = description.trim().length > 0 && description.trim().length <= 1000;
    var disabled = !nameOk || !descriptionOk;
    // Event handlers
    var handleConfirm = function () {
        props.onConfirm({
            name: name.trim(),
            description: description.trim(),
            published: published,
        });
        // Reset state
        setName('');
        setDescription('');
        setPublished(false);
    };
    return (_jsx(Modal2, __assign({ title: "Create Event", open: props.open, onCancel: props.onCancel, onConfirm: handleConfirm, disabled: disabled }, { children: _jsxs(List, { children: [_jsx(ListItemInput, { type: "text", label: "Name", value: name, onChange: setName, placeholder: "My event" }, void 0),
                _jsx(ListItemTextArea, { label: "Description", value: description, onChange: setDescription, placeholder: "Event description", rows: 20, maxLength: 1000 }, void 0),
                _jsx(ListItemSwitch, { primary: "Published", wrapPrimary: true, checked: published, onClick: function () { return setPublished(!published); } }, void 0)] }, void 0) }), void 0));
}
//# sourceMappingURL=create-event-modal.js.map